// src/context/MQTTContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import MQTTService from '../mqttService';

const MQTTContext = createContext();

export const MQTTProvider = ({ children }) => {
  const [mqttData, setMqttData] = useState(null);
  const {
    connectStatus,
    payload,
    mqttConnect,
    mqttSub,
    mqttUnSub,
    mqttPublish,
    mqttDisconnect,
  } = MQTTService();

  useEffect(() => {
    if (payload) {
      setMqttData(payload);
    }
  }, [payload]);

  return (
    <MQTTContext.Provider value={{ mqttData, connectStatus, mqttConnect, mqttSub, mqttUnSub, mqttPublish, mqttDisconnect }}>
      {children}
    </MQTTContext.Provider>
  );
};

export const useMQTT = () => useContext(MQTTContext);